import moment from 'moment'
import {
  createNamespacedHelpers,
} from 'vuex'
const stations = createNamespacedHelpers('stations')

export default {
  methods: {
    checkStationLocation(x) {
      return x.position !== null && x.position.lat !== null && x.position.lng !== null &&
        !isNaN(x.position.lat) && !isNaN(x.position.lng) &&
        (x.position.lat >= -90 && x.position.lat <= 90 && x.position.lng >= -180 && x.position.lng <= 180)
    },
    getDataTimeRange(datasets) {
      var allStartDate = datasets.map(x => moment(x.FirstRecordDate).valueOf())
      var allEndDate = datasets.map(x => moment(x.LastRecordDate).valueOf())
      var minDate = Math.min.apply(Math, allStartDate)
      var maxDate = Math.max.apply(Math, allEndDate)
      return [moment(minDate), moment(maxDate)]
    },
    getTotolNumberOfRecords(datasets) {
      var total = datasets.map(x => x.NumberOfRecords).reduce((a, b) => a + b, 0)
      return total
    },
    getTimeSeriesName(datasets) {
      return this.getTimeSeriesNamesList(datasets).join(', ')
    },
    getTimeSeriesNamesList(datasets) {
      var names = datasets.map(x => x.DataSetIdentifer.substring(
        x.DataSetIdentifer.indexOf('.') + 1,
        x.DataSetIdentifer.indexOf('@')
      ))
      let uniqueNames = names.filter((item, index) => names.indexOf(item) === index)
      return uniqueNames
    },
  },
  computed: {
    ...stations.mapGetters(['distinctStations']),
    stationName() {
      if (this.station && this.station.name) {
        return this.station.name
      } else {
        return ''
      }
    },
    stationGPS() {
      if (this.station != null && this.station.position != null && this.station.position.lat != null && this.station.position.lng != null) {
        return this.station.position.lat + ',' + this.station.position.lng
      }
      return ''
    },
  },
}